import { render, staticRenderFns } from "./SupplierDashboard.vue?vue&type=template&id=7bbe7ba0&scoped=true&lang=pug&"
import script from "./SupplierDashboard.vue?vue&type=script&lang=ts&"
export * from "./SupplierDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./SupplierDashboard.vue?vue&type=style&index=0&id=7bbe7ba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbe7ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
